import { isIPad } from '~/modules/viewer/userAgent'
import { initializeDisplaySize, dsResizedEvent } from '~/static/js/functions'

/**
 * Window Initializer Plugin
 *
 * windowイベント系など、初回のみ設置したい処理をここに記載していく
 */
export default () => {
  // ---------------
  // EL_2ND-1317対応
  // ---------------

  // HACK: スコープ的にここに持つのはよくないのでNuxt3移植時にはこんなことをしなくて良いように計算すること！！！
  // 初期ロード時のウィンドウサイズを保持しておく
  // ※学習画面などは縦スクロールが発生するため、高さは保持しない
  const _initialWidth = window.document.documentElement.clientWidth

  // サイズ変更検知のハンドラ関数
  const windowSizeHandler = () => {
    if (isIPad()) {
      const currentWidth = window.document.documentElement.clientWidth
      const currentHeight = window.document.documentElement.clientHeight
      const innerWidth = window.innerWidth
      // 横向きの場合のみ発火
      const isLandscape = currentWidth > currentHeight
      // 初期状態から横幅が変わった、または拡大されている場合
      if (isLandscape && (currentWidth !== _initialWidth || currentWidth !== innerWidth)) {
        window.location.reload()
      }
    } else {
      // iPad以外は通常のリサイズ処理
      dsResizedEvent()
    }
  }

  // focus（復帰した時のイベント）
  window.addEventListener('focus', windowSizeHandler)
  // resize event
  window.addEventListener('resized', function (e: Event) {
    // iPadでリサイズが走った場合、functions.jsにある元々のイベントをキャンセルしてリサイズイベントに移動させる
    if (isIPad()) {
      e.stopPropagation()
      windowSizeHandler()
    }
  })

  // 初回時のみDisplaySize変更を設置（複数回実施を回避）
  initializeDisplaySize()
}
